const commonStyles = {
  container: {
    margin: 32,
    borderRadius: 8,
    overflow: "hidden",
    position: "relative",
  },
  closeIconContainer: {
    position: "absolute",
  },
  closeIconWrapper: {
    borderRadius: "50%",
    cursor: "pointer",
    padding: 8,
    color: "neutral.0",
  },
  contentContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    minHeight: "164px",
  },
  title: {
    fontSize: 20,
    textAlign: "center",
  },
  member: {
    opacity: 0.7,
    textTransform: "uppercase",
    textAlign: "center",
  },
  subtitle: {
    textAlign: "center",
  },
};

const styles = {
  ED: {
    container: {
      ...commonStyles.container,
    },
    closeIconContainer: commonStyles.closeIconContainer,
    closeIconWrapper: {
      ...commonStyles.closeIconWrapper,
      backgroundColor: "transparent",
    },
    contentContainer: commonStyles.contentContainer,
    title: commonStyles.title,
    member: commonStyles.member,
    subtitle: {
      ...commonStyles.subtitle,
      color: "#FFD633",
    },
  },
  OP: {
    container: {
      ...commonStyles.container,
    },
    closeIconContainer: commonStyles.closeIconContainer,
    closeIconWrapper: {
      ...commonStyles.closeIconWrapper,
      backgroundColor: "transparent",
    },
    contentContainer: commonStyles.contentContainer,
    title: commonStyles.title,
    member: commonStyles.member,
    subtitle: {
      ...commonStyles.subtitle,
      color: "#FF6600",
    },
  },
  GO: {
    container: {
      ...commonStyles.container,
    },
    closeIconContainer: commonStyles.closeIconContainer,
    closeIconWrapper: {
      ...commonStyles.closeIconWrapper,
      backgroundColor: "transparent",
    },
    contentContainer: commonStyles.contentContainer,
    title: commonStyles.title,
    member: commonStyles.member,
    subtitle: {
      ...commonStyles.subtitle,
      color: "white",
    },
  },
  TR: {
    container: {
      ...commonStyles.container,
    },
    closeIconContainer: commonStyles.closeIconContainer,
    closeIconWrapper: {
      ...commonStyles.closeIconWrapper,
      backgroundColor: "transparent",
    },
    contentContainer: commonStyles.contentContainer,
    title: commonStyles.title,
    member: commonStyles.member,
    subtitle: {
      ...commonStyles.subtitle,
      color: "#FFD633",
    },
  },
};

export default styles;
